import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../../api/api_client';
import { loadingSlice } from './loading';

export const defaultEntryState = {
    entries: [],
    drawings: [],
    collection: [],
    points: 0,
    last_entry: null,
    game_over: false,
    error: '',
};

// REDUCERS
// basic actions that affect this object only

const getEntriesReducer = (state, action) => {
    const { entries = [] } = action.payload;

    const promotionGames = [1574, 1575, 1577, 1578, 1579];

    const promotionEntries = entries.filter(entry => {
        return promotionGames.indexOf(parseInt(entry.game_id, 10)) !== -1;
    });

    const combinedEntryTypesObject = promotionEntries.reduce(
        (combinedEntries, currentEntry) => {
            // the current drawings should only be category 1
            // the final draw should be category 2 but as of
            /// now will likely not be visible
            if (parseInt(currentEntry.category, 10) > 1) {
                return combinedEntries;
            }
            // combine this value with what is present already
            // when script_id != 0 the entry amount is always 1 and the script_id
            // indicates the multiplier level
            if (
                typeof combinedEntries[currentEntry.ticket_number] !==
                'undefined'
            ) {
                // we have the multiplier already so add the points and
                // multiplier from the new "non multiplier" entry
                if (
                    combinedEntries[currentEntry.ticket_number]['script_id'] !==
                    '0'
                ) {
                    combinedEntries[currentEntry.ticket_number] = {
                        ...combinedEntries[currentEntry.ticket_number],
                        points: currentEntry.points,
                        multiplier: currentEntry.multiplier,
                    };
                } else {
                    // the new entry is the multiplier entry so add the script_id
                    combinedEntries[currentEntry.ticket_number] = {
                        ...combinedEntries[currentEntry.ticket_number],
                        script_id: currentEntry.script_id,
                    };
                }
            } else {
                // add the entry
                combinedEntries[currentEntry.ticket_number] = currentEntry;
            }

            return combinedEntries;
        },
        {}
    );

    const combinedEntryTypes = Object.keys(combinedEntryTypesObject).map(
        k => combinedEntryTypesObject[k]
    );

    const points = combinedEntryTypes.reduce((sum, val) => {
        return sum + parseInt(val.points);
    }, 0);

    return {
        ...state,
        entries: combinedEntryTypes,
        points: points,
        drawings: action.payload.drawings,
        collection: action.payload.collection,
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultEntryState,
    };
};

const setLastEntryReducer = (state, action) => {
    return {
        ...state,
        last_entry: action.payload,
    };
};

const clearErrorsReducer = (state, action) => {
    return {
        ...state,
    };
};

export const entrySlice = createSlice({
    name: 'entry',
    initialState: defaultEntryState,
    reducers: {
        getEntries: getEntriesReducer,
        reset: resetReducer,
        setLastEntry: setLastEntryReducer,
        clearErrors: clearErrorsReducer,
    },
});

//ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const getEntries = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading());
    const result = await apiClient.getEntries(payload);
    dispatch(entrySlice.actions.getEntries(result));
    dispatch(loadingSlice.actions.unsetLoading());
};

//actions that get exported to the views
export const entryActions = dispatch => {
    return {
        getEntries: payload => getEntries(dispatch, payload),
        reset: payload => dispatch(entrySlice.actions.reset(payload)),
        setLastEntry: payload =>
            dispatch(entrySlice.actions.setLastEntry(payload)),
        clearErrors: payload => dispatch(entrySlice.actions.clearErrors()),
    };
};
